import t from "../locales/common.json";

<let/timeRange=(start: Date, end: Date) => {
  let formatter = Intl.DateTimeFormat($global.locale || "it", {
    hour: "numeric",
    minute: "numeric",
  });
  return t.cc.Timetable.hourRange
    .replaceAll("{{start, datetime}}", formatter.format(start))
    .replaceAll("{{end, datetime}}", formatter.format(end));
}>

static const time = (hour: number, minute: number) =>
  new Date(1970, 1, 1, hour, minute);

<div>
  <heading-3 class="text2 mbe1 flex align-items-center" style={ gap: ".6ex" }>
    ${t.cc.Timetable.header}
    <svg
      aria-hidden="true"
      style={ height: "2ex" }
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15.6879" cy="15.0076" r="14.9656" fill="var(--back)"/>
      <path
        d="M15.678 17.6958L22.6006 14.658"
        stroke="var(--fore)"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M15.678 17.6958L8.87842 8.50708"
        stroke="var(--fore)"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  </heading-3>
  <div class="flow font-light" style=`--flow-space": "var(--space--2)`>
    <div>${t.cc.Timetable.openDays}</div>
    <p class="leading4">
      <span>${timeRange(time(10, 0), time(13, 0))}</span><br>
      <span>${timeRange(time(14, 0), time(19, 0))}</span>
    </p>
  </div>
</div>
